<template>
  <b-form-group id="i18nRadio" horizontal label-cols="3" label-size="md" :label="$t('labels.language') + ':'">
    <b-row>
      <b-col lg="5">
        <label for="EN" class="customi_label">
          <input type="radio" id="EN" name="locale" value="EN" class="invisible customi_input" v-model="locale">
          <div class="customi_div radio">
            <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
              <circle class="svg_bg" cx="10" cy="10" r="9"/>
              <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
            </svg>
          </div>
          <span>English</span>
        </label>
      </b-col>
      <b-col lg="5">
        <label for="ES" class="customi_label">
          <input type="radio" id="ES" name="locale" value="ES" class="invisible customi_input" v-model="locale">
          <div class="customi_div radio">
            <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
              <circle class="svg_bg" cx="10" cy="10" r="9"/>
              <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
            </svg>
          </div>
          <span>Castellano</span>
        </label>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
export default {
  name: 'i18nRadio',
  data () {
    return {
      locale: localStorage.getItem('i18n') ? localStorage.getItem('i18n') : 'EN',
      checked: true
    };
  },
  watch: {
    locale (val) {
      localStorage.setItem('i18n', val);
      this.$i18n.locale = val.toLowerCase();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Settings/i18n.vue